import React from 'react';
import { Product, ProductParameter, ProductParameterValueOfImageBrowser, ProductConfiguration, productParametersMultiple, productConfigurationContainsValue, ProductParameterValueFile } from '../model';
import { htmlDecode } from '../../../core/html';
import Button from '@material-ui/core/Button';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';

export interface ProductCategoryDto {
    id: number;
    name: string;
    slug: string;
}

export interface ProductDimensionsDto {
    length: string;
    width: string;
    height: string;
}

export interface ProductImageDto {
    id: number;
    date_created: Date;
    date_created_gmt: Date;
    date_modified: Date;
    date_modified_gmt: Date;
    src: string;
    name: string;
    alt: string;
}

export interface ProductMetadataDto {
    id: number;
    key: string;
    value: string | object;
}

export interface ProductParameterDto {
    term_id: number;
    name: string;
    slug: string;
    term_group: number;
    term_taxonomy_id: number;
    taxonomy: string;
    description: string;
    parent: number;
    count: number;
    filter: string;
    price: string;
    featured_image: string;
    multiplier?: string;
}

export interface ProductTemplateFileDto {
    title: string;
    url: string;
}

export interface ProductDesignDto {
    design_image: string;
}

export interface ProductDto {
    defaultParametersManual?: string;
    _links: { [key: string]: { href: string; }[]; };
    attributes: [];
    designOptions: any[];
    availableConnections: { [typeId: number]: { [parameterKey: string]: number | number[] | false; }[]; };
    average_rating: string;
    backorders: string;
    backorders_allowed: boolean;
    backordered: boolean;
    button_text: string;
    catalog_visibility: string;
    categories: ProductCategoryDto[];
    cross_sell_ids: any[];
    currency: string;
    description: string;
    date_created: Date;
    date_created_gmt: Date;
    date_modified: Date;
    date_modified_gmt: Date;
    date_on_sale_from: Date;
    date_on_sale_from_gmt: Date;
    date_on_sale_to: Date;
    date_on_sale_to_gmt: Date;
    default_attributes: [];
    defaults: { [key: string]: string; };
    design_cost: string;
    designs: { [key: string]: ProductDesignDto[]; };
    dimensions: ProductDimensionsDto;
    downloadable: boolean;
    downloads: any[];
    download_limit: number;
    download_expiry: number;
    external_url: string;
    featured: boolean;
    grouped_products: [];
    id: number;
    images: ProductImageDto[];
    manage_stock: boolean;
    menu_order: number;
    meta_data: ProductMetadataDto[];
    name: string;
    on_sale: boolean;
    parameters: { [type: string]: ProductParameterDto[]; };
    parameters_labels: { [type: string]: string; };
    parent_id: number;
    permalink: string;
    price: string;
    price_html: string;
    purchasable: boolean;
    purchase_note: string;
    regular_price: string;
    rating_count: number;
    related_ids: number[];
    reviews_allowed: boolean;
    sale_price: string;
    shipping_required: boolean;
    shipping_taxable: boolean;
    shipping_class: string;
    shipping_class_id: number;
    slug: string;
    short_description: string;
    sku: string;
    sold_individually: boolean;
    status: string;
    stock_quantity: number;
    stock_status: string;
    tags: [];
    tax_class: string;
    tax_status: string;
    templates: {
        files: ProductTemplateFileDto[];
        templateInfo: string;
        templateManualInfo: string;
    };
    total_sales: number;
    type: string;
    upsell_ids: any[];
    variations: [];
    virtual: boolean;
    weight: string;
}

export interface ProductAddToCartRequestDto {
    product_id: number;
    quantity: number;
    cart_item_data: {
        parameters: {
            types: number;
            fabrics: number;
            finishings: number;
            hardwares: number[];
        },
        designs:
        {
            kind: number,
            file: string,
            comment: string;
        }[];
    };
}

export interface ProductMediaCreateItemRequestDto {

}

interface ProductMediaCreateItemSmushSize {
    percent: number;
    bytes: number;
    size_before: number;
    size_after: number;
    time: number;
}

interface ProductMediaCreateItemMediaDetailsSize {
    file: string;
    width: number;
    height: number;
    mime_type: string;
    source_url: string;
}

export interface ProductMediaCreateItemLink {
    embeddable?: boolean,
    href: string;
}

export interface ProductMediaCreateItemResponseDto {
    id: number;
    date: Date;
    date_gmt: Date;
    guid: {
        rendered: string;
        raw: string;
    },
    modified: Date;
    modified_gmt: Date;
    slug: string;
    status: string;
    type: string;
    link: string;
    title: {
        raw: string;
        rendered: string;
    },
    author: number;
    comment_status: string;
    ping_status: string;
    template: string;
    meta: [];
    permalink_template: string;
    generated_slug: string;
    smush: {
        stats: {
            percent: number;
            bytes: number;
            size_before: number;
            size_after: number;
            time: number;
            api_version: string;
            lossy: boolean;
            keep_exif: number;
        },
        sizes: {
            thumbnail: ProductMediaCreateItemSmushSize;
            medium: ProductMediaCreateItemSmushSize;
            medium_large: ProductMediaCreateItemSmushSize;
            woocommerce_thumbnail: ProductMediaCreateItemSmushSize;
            woocommerce_single: ProductMediaCreateItemSmushSize;
            woocommerce_gallery_thumbnail: ProductMediaCreateItemSmushSize;
            shop_catalog: ProductMediaCreateItemSmushSize;
            shop_single: ProductMediaCreateItemSmushSize;
            shop_thumbnail: ProductMediaCreateItemSmushSize;
        };
    },
    description: {
        raw: string;
        rendered: string;
    };
    caption: {
        raw: string;
        rendered: string;
    };
    alt_text: string;
    media_type: string;
    mime_type: string;
    media_details: {
        width: number;
        height: number;
        file: string;
        sizes: {
            thumbnail: ProductMediaCreateItemMediaDetailsSize;
            medium: ProductMediaCreateItemMediaDetailsSize;
            medium_large: ProductMediaCreateItemMediaDetailsSize;
            woocommerce_thumbnail: ProductMediaCreateItemMediaDetailsSize;
            woocommerce_single: ProductMediaCreateItemMediaDetailsSize;
            woocommerce_gallery_thumbnail: ProductMediaCreateItemMediaDetailsSize;
            shop_catalog: ProductMediaCreateItemMediaDetailsSize;
            shop_single: ProductMediaCreateItemMediaDetailsSize;
            shop_thumbnail: ProductMediaCreateItemMediaDetailsSize;
            full: ProductMediaCreateItemMediaDetailsSize;
        };
        image_meta: {
            aperture: string;
            credit: string;
            camera: string;
            caption: string;
            created_timestamp: string;
            copyright: string;
            focal_length: string;
            iso: string;
            shutter_speed: string;
            title: string;
            orientation: string;
            keywords: [];
        };
    };
    post: null;
    source_url: string;
    _links: {
        self: ProductMediaCreateItemLink[];
        collection: ProductMediaCreateItemLink[];
        about: ProductMediaCreateItemLink[];
        author: ProductMediaCreateItemLink[];
        replies: ProductMediaCreateItemLink[];
        "wp:action-unfiltered-html": ProductMediaCreateItemLink[];
        "wp:action-assign-author": ProductMediaCreateItemLink[];
        curies: ProductMediaCreateItemLink[];
    };
}

export interface ProductMediaDeleteItemResponseDto {

}

export const productMediaCreateItemResponseDtoToProductParameterValueFile = (response: ProductMediaCreateItemResponseDto): ProductParameterValueFile => ({
    id: response.id,
    url: response.source_url
});

export function productToAddToCartRequestDto(product: Product, productParameters: ProductParameter[]): ProductAddToCartRequestDto {
    const parameters: { [key: string]: number | { id: number; }[]; } = {};
    Object.keys(product.configuration).forEach(key => {
        const configItem = product.configuration[key];
        if (!configItem || !configItem.length) return;
        const productParameter = productParameters.find(it => it.key === key);
        if (!productParameter) return;
        parameters[key] = productParameter.multiple
            ? configItem.map(it => ({ id: parseInt(it.key) }))
            : parseInt(configItem[0].key);
    });
    const design = product.configuration['design'];
    const designKeyToKind: { [key: string]: number; } = {
        project: 0,
        library: 1,
        own: 2,
        later: 3
    };
    const request = {
        product_id: parseInt(product.id),
        quantity: parseInt(product.configuration['quantity'][0].key),
        cart_item_data: {
            parameters: parameters as any,
            designs: !design || !design.length
                ? []
                : design
                    .filter(kind => (kind.filesUploaded && kind.filesUploaded.length) || !!kind.valueSelected)
                    .map(
                        kind => kind.filesUploaded && kind.filesUploaded.length
                            ? kind.filesUploaded
                                .map(file => ({
                                    kind: designKeyToKind[kind.key],
                                    file: file.url,
                                    comment: kind.description
                                }))
                            : [{
                                kind: designKeyToKind[kind.key],
                                file: kind.valueSelected.key,
                                comment: kind.description
                            }]
                    )
                    .reduce((prev, curr) => prev.concat(curr), [])
        }
    };
    if (!request.cart_item_data.designs.length && design.length) {
        request.cart_item_data.designs.push({
            kind: designKeyToKind[design[0].key],
            file: '',
            comment: ''
        });
    }
    return request;
}

export function productDtoToConfiguration(dto: ProductDto): ProductConfiguration {
    const config: ProductConfiguration = {
        quantity: [{ key: '1', label: '1', price: 0, priceMultiplier: 1 }],
        design: [{ key: 'designDefaultLabel', label: 'Please choose an option', price: NaN, priceMultiplier: 1 }]
    };
    Object.keys(dto.defaults).forEach(key => {
        const value = dto.defaults[key];
        const parameter = dto.parameters && key in dto.parameters && Array.isArray(dto.parameters[key])
            ? dto.parameters[key].find(it => it.term_id.toString() === value)
            : undefined;
        if (!parameter) return;
        if (!(key in config)) config[key] = [];
        config[key].push({ key: value, label: parameter.name, price: parseFloat(parameter.price), priceMultiplier: isNaN(parseFloat(parameter.multiplier)) ? 1 : parseFloat(parameter.multiplier) });
    });
    return config;
}

export const productDtoToProduct = (dto: ProductDto): Product => ({
    categories: dto.categories.map(it => it.name),
    configuration: productDtoToConfiguration(dto),
    configurationDefault: productDtoToConfiguration(dto),
    description: [
        {
            label: 'Information',
            content: dto.short_description
        },
        {
            label: 'Specification',
            content: dto.description
        },
        {
            label: 'Templates',
            contentElement: () => <div className='ProductDescriptionTemplates-root'>
                <div className='ProductDescriptionTemplates-info' dangerouslySetInnerHTML={{ __html: htmlDecode(dto.templates.templateInfo) }}></div>
                <ul className='ProductDescriptionTemplates-filesContainer'>
                    {dto.templates.files.map((file, index) => <li key={index} className='ProductDescriptionTemplates-fileItem'>
                        <div className='ProductDescriptionTemplates-fileTitleContainer'>
                            {file.title}
                        </div>
                        <div className='ProductDescriptionTemplates-fileButtonContainer'>
                            <Button
                                variant='contained'
                                color='primary'
                                href={file.url}
                                target='_blank'
                            >
                                <PictureAsPdf />
                                Download
                            </Button>
                        </div>
                    </li>)}
                </ul>
                <div className='ProductDescriptionTemplates-manual' dangerouslySetInnerHTML={{ __html: htmlDecode(dto.templates.templateManualInfo) }}></div>
            </div>
        }
    ],
    id: dto.id.toString(),
    images: dto.images,
    price: parseFloat(dto.price),
    designCost: parseFloat(dto.design_cost),
    currency: dto.currency,
    name: dto.name,
    sku: dto.sku
});

function productDtoToParameterConstraints(dto: ProductDto, key: string, parameter: ProductParameterDto) {
    if (key !== 'types' || !(parameter.term_id in dto.availableConnections))
        return undefined;
    const result = dto.availableConnections[parameter.term_id]
        .map(ac => {
            const constraints = {};
            for (key in ac) {
                const raw = ac[key];
                if (!(key in constraints))
                    constraints[key] = [];
                switch (typeof raw) {
                    case 'number':
                        constraints[key].push(raw.toString());
                        break;
                    case 'object':
                        if (Array.isArray(raw)) {
                            raw.forEach(v => {
                                if (typeof v === 'number')
                                    constraints[key].push(v.toString());
                            });
                        }
                        break;
                }
            }
            return constraints;
        });
    return result;
}

export const productDtoToParameters = (dto: ProductDto): ProductParameter[] => [
    ...[{ input: 'IntegerField', key: 'quantity', label: 'Quantity', valueProvider: { range: { min: 1, max: dto.stock_quantity } } } as ProductParameter],
    ...Object.keys(dto.parameters).filter(key => dto.parameters[key]).map((key, index) => {
        const multiple = productParametersMultiple.indexOf(key) !== -1;
        return ({
            input: 'ImageBrowser',
            key: key,
            label: dto.parameters_labels[key],
            disabled: key !== 'types' && (!dto.defaults || !(key in dto.defaults) || !dto.defaults[key]),
            valueProvider: {
                list: Array.isArray(dto.parameters[key])
                    ? dto.parameters[key].map(parameter => ({
                        key: parameter.term_id.toString(),
                        label: parameter.name,
                        imageUrl: parameter.featured_image,
                        price: parseFloat(parameter.price),
                        constraints: productDtoToParameterConstraints(dto, key, parameter),
                        priceMultiplier: parseFloat(parameter.multiplier)
                    } as ProductParameterValueOfImageBrowser))
                    : []
            },
            multiple
        } as ProductParameter);
    }),
    // Show design option for all products
    // ...(!dto.designs || (Array.isArray(dto.designs) && !dto.designs.length) || !Object.keys(dto.designs) ? [] : [
    ...(!dto.designs || !Object.keys(dto.designs) ? [] : [
        {
            input: 'ButtonBrowser',
            key: 'design',
            label: 'Design',
            manual: dto.defaultParametersManual,
            valueProvider: {
                list: [
                    { key: 'own', label: 'I do have it', price: 0 },
                    { key: 'project', label: 'Do it for me', price: parseFloat(dto.design_cost) },
                    {
                        key: 'library',
                        label: 'Choose from library',
                        price: 0,
                        valueProvider: {
                            list: dto.designs && Object.keys(dto.designs).length
                                ? Object
                                    .keys(dto.designs)
                                    .map(key => dto.designs[key])
                                    .reduce((prev, curr) => prev.concat(curr))
                                    .map(design => ({
                                        key: design.design_image,
                                        label: design.design_image,
                                        price: 0
                                    }))
                                : []
                        }
                    },
                    { key: 'later', label: 'Later', price: NaN }
                ]
            },
            multiple: false
        } as ProductParameter
    ])
];
